export const LaCon = 'http://api.agendavacina.app.br/'//'http://192.168.15.10:8000/';//'http://api.doevidas.com.br/';//'http://127.0.0.1:8000/'//
export const SelfLink = 'http://homolog.agendavacina.app.br/';
export const Passport = 'SB0ccaiSYeve3A2B8WLOgvAOwq8nJqbgMXUgejRW';